import { Link } from 'react-router-dom';

interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  imageUrl: string;
}

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.id}`} className="block cursor-pointer">
        <div className="h-44 bg-background-100 overflow-hidden relative">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <Link
            to={`/category/${article.category}`}
            className="text-accent-600 hover:text-accent-700 font-medium cursor-pointer whitespace-nowrap"
          >
            {article.categoryName}
          </Link>
          <span>·</span>
          <span>{article.publishDate}</span>
          <span>·</span>
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-xs"></i>
            </div>
            {article.readCount.toLocaleString()}
          </span>
        </div>
        <Link to={`/article/${article.id}`} className="block cursor-pointer group">
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs text-secondary-700 bg-secondary-50 px-2 py-0.5 rounded whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}